import DefaultMapper, { addCustomMethods } from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

const PAYMENTS_API_PATH = 'wallet/tx/payments';

class PaymentFailureMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'wallet/tx/payments/failures';
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		options.method = 'POST';
		if (params.method) {
			options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.id}${addCustomMethods(
				params
			)}`;
		} else {
			options.url = `${API_BASE_PATH_ADMIN}/${PAYMENTS_API_PATH}/${
				params.data.paymentId
			}/failures`;
			options.body = JSON.stringify({
				paymentFailureType: params.data.paymentFailureType,
				failureAmount: params.data.failureAmount,
				failureCurrency: params.data.failureCurrency,
				description: params.data.description,
				externalReferenceId: params.data.externalReferenceId
			});
		}
	}
}

export default PaymentFailureMapper;
